// Decode HTML Entities
function decodeHtmlEntities(str) {
  const parser = new DOMParser();
  return parser.parseFromString(`<!doctype html><body>${str}`, 'text/html').body.textContent;
}

// Global Cart Object
window.Cart = {
  initialize: function() {
    console.log('Initializing cart...');
    this.fetchCart()
      .then(cart => {
        this.updateDrawer(cart);
        this.updateCounter(cart);
        this.setupButtonEventListeners(); 
      })
      .catch(error => {
        console.error('Error initializing cart:', error);
      });
  },

  fetchCart: function() {
    return fetch('/cart.js')
      .then(response => {
        if (!response.ok) throw new Error('Failed to fetch cart.');
        return response.json();
      });
  },

   setupButtonEventListeners: function() {
    const cartContainer = document.querySelector('.cart-wrapper');
    //const cartContainer = document.body;

    // Attach event listener to the cart drawer container
    if (cartContainer) {
      cartContainer.addEventListener('click', function(e) {
        const target = e.target.closest('[data-action]');
        if (!target) return;

        e.preventDefault();
        e.stopPropagation();

        const action = target.getAttribute('data-action');
        const input = target.parentElement.querySelector('input[type="number"]');
        const key = input ? input.dataset.key : target.dataset.key; // Get key from input or button

        switch (action) {
          case 'increment':
            if (input) {
              Cart.incrementQuantity(input);
              Cart.updateLineItemQty(input);
            }
            break;
          case 'decrement':
            if (input) {
              Cart.decrementQuantity(input);
              Cart.updateLineItemQty(input);
            }
            break;
          case 'remove':
            if (key && confirm('Are you sure you want to remove this item from your cart?')) {
              Cart.changeQuantity(key, 0); // Use changeQuantity for removal
            }
            break;
        }
      });

      // Optional: Event listener for quantity input changes (if you want to handle manual input)
      cartContainer.addEventListener('change', function(e) {
        if (e.target.classList.contains('js--cart-item-qty') && e.target.dataset.action === 'update') {
          Cart.updateLineItemQty(e.target);
        }
      });
    }
  },


  updateCounter: function(cart) {
    document.querySelectorAll('.js--cart-counter').forEach(el => {
      el.innerText = cart.item_count;
    });
  },

  openDrawer: function() {
    const drawer = document.getElementById('cart-drawer');
    if (drawer) {
      drawer.style.display = 'block';
      drawer.offsetHeight;
      drawer.classList.add('active');
      document.body.style.overflow = 'hidden';
    }
  },

  closeDrawer: function() {
    const drawer = document.getElementById('cart-drawer');
    if (drawer) {
      drawer.classList.remove('active');
      setTimeout(() => {
        if (!drawer.classList.contains('active')) {
          drawer.style.display = 'none';
          document.body.style.overflow = '';
        }
      }, 300);
    }
  },

   updateDrawer: function(cart) {
    console.log('Updating cart drawer');
    const cartType = window.Shopify.shop.cart_type;
    console.log('Cart type:', cartType);

    // Don't update drawer if we're on the cart page
    if (window.location.pathname === '/cart') return;

    if (cartType !== 'drawer' && cartType !== 'popup') return;

    const cartDrawer = document.getElementById('cart-drawer');
    if (!cartDrawer) return console.error('Cart drawer element not found');

    const cartItemsContainer = cartDrawer.querySelector('.cart-drawer__items');
    if (!cartItemsContainer) return console.error('Cart items container not found');

    const template = document.getElementById('cart-item-template');
    if (!template) return console.error('Cart item template not found');

    cartItemsContainer.innerHTML = '';

    if (!cart.items.length) {
      cartItemsContainer.innerHTML = '<p>Your cart is empty</p>';
      return;
    }

    cart.items.forEach(item => {
      const itemElement = template.cloneNode(true);
      itemElement.removeAttribute('id');
      itemElement.removeAttribute('style');

      const link = itemElement.querySelector('a');
      if (link) link.href = item.url;

      const img = itemElement.querySelector('img');
      if (img && item.image) {
        img.src = item.image;
        img.alt = item.title;
      }

      const titleLink = itemElement.querySelector('.cart-item__details a');
      if (titleLink) {
        titleLink.href = item.url;
        titleLink.textContent = decodeHtmlEntities(item.title);
      }

      const price = itemElement.querySelector('.price');
      if (price) price.textContent = Shopify.formatMoney(item.price);

      const quantityInput = itemElement.querySelector('.js--cart-item-qty[data-action="update"]'); // Target the input with the data-action
      if (quantityInput) {
        quantityInput.value = item.quantity;
        quantityInput.dataset.key = item.key;
        quantityInput.dataset.id = item.id;
        quantityInput.addEventListener('change', (e) => {
        Cart.updateLineItemQty(e.target);
      });
    }

    const incrementButton = itemElement.querySelector('.quantity-button.plus[data-action="increment"]');
    if (incrementButton) {
      incrementButton.addEventListener('click', () => {
        const input = incrementButton.parentElement.querySelector('input[type="number"]');
        if (input) {
          Cart.incrementQuantity(input);
          Cart.updateLineItemQty(input);
        }
      });
    }

    const decrementButton = itemElement.querySelector('.quantity-button.minus[data-action="decrement"]');
    if (decrementButton) {
      decrementButton.addEventListener('click', () => {
        const input = decrementButton.parentElement.querySelector('input[type="number"]');
        if (input) {
          Cart.decrementQuantity(input);
          Cart.updateLineItemQty(input);
        }
      });
    }

    const removeButton = itemElement.querySelector('[data-action="remove"]');
    if (removeButton) {
      removeButton.dataset.key = item.key;
      removeButton.dataset.id = item.id;
      removeButton.addEventListener('click', () => {
        if (confirm('Are you sure you want to remove this item from your cart?')) {
          Cart.changeQuantity(removeButton.dataset.key, 0);
        }
      });
    }

      const total = itemElement.querySelector('.js--cart-item-total');
      if (total) total.textContent = Shopify.formatMoney(item.line_price);

      cartItemsContainer.appendChild(itemElement);
    });

    const totalElement = cartDrawer.querySelector('.js--cart-total');
    if (totalElement) totalElement.textContent = Shopify.formatMoney(cart.total_price);

    //this.setupButtonEventListeners();
  },

  handleAddToCart: function(form) {
    const cartType = window.Shopify.shop.cart_type;
    const formData = new FormData(form);
    const quantity = formData.get('quantity') || 1;
    const id = formData.get('id');

    const item = { items: [{ id, quantity: parseInt(quantity) }] };

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify(item)
    })
    .then(response => response.json())
    .then(addedItem => {
      console.log("Added item:", addedItem);
      return this.fetchCart();
    })
    .then(cart => {
      console.log("Cart items:", cart.items);
      this.updateCounter(cart);
      if (cartType === 'drawer' || cartType === 'popup') {
        this.updateDrawer(cart);
      }
      if (cartType === 'page') window.location.href = '/cart';
      if (cartType === 'popup') {
        // Find the newly added item in the cart using variant_id
        const newItem = cart.items.find(cartItem => cartItem.variant_id === parseInt(id));
        console.log("Found new item:", newItem);
        if (newItem) {
          // Create a copy of the item with just the added quantity
          const popupItem = {
            ...newItem,
            quantity: parseInt(quantity) // Use the quantity that was just added
          };
          showCartPopup(popupItem);
        }
      }
      if (cartType === 'drawer') this.openDrawer();
    })
    .catch(error => {
      console.error('Error:', error);
      alert('There was an error adding the item to your cart. Please try again.');
    });
  },

  updateLineItemQty: function(el) {
    const key = el.dataset.key;
    const quantity = parseInt(el.value);

    if (!key || isNaN(quantity)) return;

    this.changeQuantity(key, quantity);
  },

  changeQuantity: function(key, quantity) {
    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity })
    })
    .then(response => response.json())
    .then(cart => {
      this.updateCounter(cart);
      if (window.location.pathname === '/cart') {
         console.log("Updating price");
         this.updatePrice(cart);
      } else {
        const cartType = window.Shopify.shop.cart_type;
        if (cartType === 'drawer' || cartType === 'popup') {
          this.updateDrawer(cart);
        }
      }

    })
    .catch(error => console.error('Error updating cart item quantity:', error));
  },

  incrementQuantity: function(input) { // Expect the input element
    input.value = parseInt(input.value) + 1;
  },

  decrementQuantity: function(input) { // Expect the input element
    if (parseInt(input.value) > 1) {
      input.value = parseInt(input.value) - 1;
    }
  },
  updatePrice: function(cart){
    const cartContainer = document.querySelector('.cart-wrapper');
    cart.items.forEach(item => {
      const qtyInput = document.querySelector(`input[data-key="${item.key}"]`);
      let totalEl = qtyInput?.closest('.cart-item')?.querySelector('.js--cart-item-total');
      
      if (totalEl) totalEl.textContent = Shopify.formatMoney(item.line_price);
    });

    const totalCart = cartContainer.querySelector('.js--cart-total');
    if (totalCart) totalCart.textContent = Shopify.formatMoney(cart.total_price);
  }

};

// Cart Popup Functions
function showCartPopup(item) {
  const popup = document.getElementById('cart-popup');
  if (!popup) return;

  const image = popup.querySelector('#popup-item-image');
  const title = popup.querySelector('#popup-item-title');
  const price = popup.querySelector('#popup-item-price');
  const quantity = popup.querySelector('#popup-item-quantity');

  console.log(item);

  if (image && item.image) {
    image.src = item.image;
    image.alt = item.title;
  }
  if (title) title.textContent = decodeHtmlEntities(item.title);
  if (price) price.textContent = Shopify.formatMoney(item.price);
  if (quantity) quantity.textContent = `Qty: ${item.quantity}`;

  popup.style.display = 'block';
  setTimeout(() => (popup.style.opacity = '1'), 10);
  setTimeout(closeCartPopup, 3000);
}

function closeCartPopup() {
  const popup = document.getElementById('cart-popup');
  if (!popup) return;
  popup.style.opacity = '0';
  setTimeout(() => (popup.style.display = 'none'), 300);
}

// Gift Wrap Functions
function runGiftWrap() {
  const $this = event.target;
  const lineItemTitle = $this.getAttribute("data-item-title");
  const lineItemKey = $this.value;

  if ($this.checked) {
    addGiftWrap(lineItemTitle, lineItemKey);
  } else {
    removeGiftWrap(lineItemKey);
  }
}

function addGiftWrap(lineItemTitle, lineItemKey) {
  const data = {
    items: [{
      id: giftWrap.id,
      quantity: 1,
      properties: { Item: lineItemTitle, _id: lineItemKey }
    }]
  };

  fetch("/cart/add.js", {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(data)
  })
  .then(response => response.json())
  .then(() => Cart.fetchCart().then(cart => {
    Cart.updateCounter(cart);
    Cart.updateDrawer(cart);
  }));
}

function removeGiftWrap(lineItemKey) {
  Cart.fetchCart().then(cart => {
    const item = cart.items.find(item => item.properties && item.properties["_id"] === lineItemKey);
    if (!item) return;

    fetch("/cart/change.js", {
      method: "POST",
      headers: { "Content-Type": "application/json" },
      body: JSON.stringify({ id: item.key, quantity: 0 })
    })
    .then(response => response.json())
    .then(cart => {
      Cart.updateCounter(cart);
      Cart.updateDrawer(cart);
    });
  });
}

